<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute fixed-top " id="navigation-example">
  <div class="container-fluid">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-just-icon btn-white btn-fab btn-round" (click)="toggleMiniSidebar()">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </button>
      </div>
      <a class="navbar-brand d-md-block" href="javascript:void(0)" *ngIf="breadcrumb">{{breadcrumb}}</a>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle" data-target="#navigation-example">
      <span class="sr-only">Toggle</span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
    </button>

    <!--<ul class="navbar-nav">
      <li class="nav-item d-none d-sm-none d-lg-block d-md-block pr-5">
        <a class="nav-link" href="javascript:void(0)" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="material-icons">person</i>
        </a>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
          <a class="dropdown-item" href="javascript:void(0)" [routerLink]="['change-password']">Change Password</a>
        </div>
      </li>
      <li class="nav-item">
        <a class="logout text-rose" href="javascript:void(0)" (click)="logOutUser()"><i class="fa fa-power-off">&nbsp;Sign Out</i></a>
      </li>
    </ul>-->
    <div class="header_dropdown u-header-right">
      <!-- User Profile -->
      <div class="admin_content dropdown ml-2">
        <a class="link-muted d-flex align-items-center" href="#" role="button" id="dropdownMenuLink"
           aria-haspopup="true" aria-expanded="false" data-toggle="dropdown">
          <img class="u-avatar--xs img-fluid rounded-circle mr-2" src="../../../../../assets/images/img1.jpg"
               alt="User Profile" style="width: 50px; background-size: cover; background-position: top center;">
          <span class="text-dark d-none d-sm-inline-block" *ngIf="userName">
            Hi! {{userName?.first_name}} <small class="fa fa-angle-down text-muted ml-1"></small>
          </span>
        </a>

        <div class="dropdown-menu dropdown-menu-right border-0 py-0 mt-3" aria-labelledby="dropdownMenuLink">
          <div class="account_dropdown">
            <div class="account_dropdown_body">
              <div class="account_dropdown_item">
                <a class="d-flex align-items-center link-dark" href="javascript:void(0)"
                   [routerLink]="['profiles']">
                  <i class="fa fa-users" aria-hidden="true"></i> View Profile
                </a>
              </div>
              <div class="account_dropdown_item">
                <a class="logout text-rose d-flex align-items-center link-dark" href="javascript:void(0)"
                   [routerLink]="['change-password']">
                  <i class="fa fa-key" aria-hidden="true"></i> Change Password
                </a>
              </div>
              <div class="account_dropdown_footer">
                <a class="d-flex align-items-center link-dark" (click)="logOutUser()">
                  <i class="fa fa-sign-out" aria-hidden="true"></i> Sign Out
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End User Profile -->
  </div>
</nav>
<!-- End Navbar -->
<br>
